import request from '../utils/request';

interface ExternalProductParams {
  agent_id: string;
  status: number;
  token: string;
  type: number;
  page: number;
  platform: string;
  source: string;
  client_api_version: string;
  appid: string;
  versionName: string;
  versionCode: number;
}

interface ExternalProductResponse {
  code: number;
  data: {
    list: any[];
    total: number;
    page: number;
    pageSize: number;
  };
  message: string;
}

// 外部接口基础配置
const EXTERNAL_API_CONFIG = {
  baseURL: 'https://h5d.lianhengkj.com',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': '*/*',
    'Accept-Language': 'zh-CN,zh;q=0.9,en;q=0.8',
    'AppChannel': 'self_1.0.272',
    'Platform': 'android',
    'Source': 'H5',
    'Client-Api-Version': '/v10/',
    'AppId': '__UNI__A23AF79',
    'VersionName': '1.0.272',
    'VersionCode': '10272',
  },
};

// 默认请求参数
const DEFAULT_PARAMS: ExternalProductParams = {
  agent_id: '7dff14e6338cb6e4b967e505d8255dd7',
  status: 1,
  token: '1',
  type: 0,
  page: 1,
  platform: 'android',
  source: 'H5',
  client_api_version: '/v10/',
  appid: '__UNI__A23AF79',
  versionName: '1.0.272',
  versionCode: 10272,
};

// 创建外部接口请求实例
const externalRequest = request.create({
  baseURL: EXTERNAL_API_CONFIG.baseURL,
  headers: EXTERNAL_API_CONFIG.headers,
});

// 获取外部产品列表
export const getExternalProducts = async (params: Partial<ExternalProductParams> = {}): Promise<ExternalProductResponse> => {
  try {
    const requestParams = {
      ...DEFAULT_PARAMS,
      ...params,
    };
    
    const response = await externalRequest.post('/v10/micro_store_list/page_goods', requestParams);
    return response.data;
  } catch (error) {
    console.error('获取外部产品列表失败:', error);
    throw error;
  }
};

// 运营商类型枚举
export enum OperatorType {
  ALL = 0,    // 全部
  MOBILE = 1, // 移动
  UNICOM = 2, // 联通
  TELECOM = 3,// 电信
  BROADCAST = 4, // 广电
}

// 获取运营商名称
export const getOperatorName = (type: OperatorType): string => {
  const operatorMap = {
    [OperatorType.ALL]: '全部',
    [OperatorType.MOBILE]: '移动',
    [OperatorType.UNICOM]: '联通',
    [OperatorType.TELECOM]: '电信',
    [OperatorType.BROADCAST]: '广电',
  };
  return operatorMap[type] || '未知';
};

// ========== 172平台 API（通过后端代理） ==========

/** 172平台产品查询参数 */
export interface ProductQuery172Params {
  page?: number;
  limit?: number;
  ProductName?: string;
  CommissionType?: string;
  Operator?: string;
  Area?: string;
  BackMoneyType?: string;
  Age1?: number;
  Age2?: number;
  NumberType?: string;
  PackageType?: string;
  SecSupplier?: string;
  PriceTime?: string;
  SendAddr?: string;
  Name1?: string;
  OnShop?: string;
  IsKuan?: string;
}

/** 172平台产品 */
export interface Product172 {
  productID: number;
  productName: string;
  price: number;
  operator: string;
  mainPic: string;
  remark: string;
  sPrice: number;
  sPriceRead: string;
  backMoneyType: string;
  firstLevelMoney: number;
  blackLevelMoney: number;
  goldenLevelMoney: number;
  busLevelMoney: number;
  area: string;
  areaRead: string;
  disableArea: string;
  rule: string;
  zhutui: boolean;
  age1: number;
  age2: number;
  isNeedSend: number;
  createTime: string;
  thirdApi: number;
  isKuanPro: number;
  isGenericPro: number;
  keyWords: string;
  [key: string]: any;
}

/** 172平台查询响应 */
export interface ProductQuery172Response {
  code: number;
  msg: string | null;
  message: string | null;
  count: number;
  data: Product172[];
}

/**
 * 查询172平台产品列表（通过后端代理）
 */
export const getProducts172 = async (params: ProductQuery172Params = {}): Promise<ProductQuery172Response> => {
  return request({
    url: '/api/products/platform-172',
    method: 'GET',
    params: {
      page: params.page ?? 1,
      limit: params.limit ?? 20,
      ProductName: params.ProductName ?? '',
      CommissionType: params.CommissionType ?? '',
      Operator: params.Operator ?? '',
      Area: params.Area ?? '',
      BackMoneyType: params.BackMoneyType ?? '',
      Age1: params.Age1 ?? 0,
      Age2: params.Age2 ?? 100,
      NumberType: params.NumberType ?? '',
      PackageType: params.PackageType ?? '',
      SecSupplier: params.SecSupplier ?? '',
      PriceTime: params.PriceTime ?? '',
      SendAddr: params.SendAddr ?? '',
      Name1: params.Name1 ?? '',
      OnShop: params.OnShop ?? '',
      IsKuan: params.IsKuan ?? '',
    },
  });
};

/**
 * 获取172平台产品详情（组合API列表数据 + h5orderEn HTML页面数据）
 */
export interface Platform172Detail {
  productInfo: Product172 | null;
  title: string;
  productName: string;
  subTitle: string;
  price: string;
  trafficSummary: {
    generalTraffic: string;
    directionalTraffic: string;
    voice: string;
  };
  productPackage: string;
  originalPlan: string;
  detailSections: Record<string, string>;
  detailImg: string;
}

export const getPlatform172Detail = async (sn: string, userSn?: string): Promise<Platform172Detail> => {
  return request({
    url: `/api/products/platform-172/${sn}/detail`,
    method: 'GET',
    params: { userSn: userSn || '' },
  });
};

export const getOperatorList172 = async (): Promise<string[]> => {
  try {
    const result = await getProducts172({ page: 1, limit: 1 });
    // 从已有数据中提取,或者调用专门的接口
    return ['移动', '联通', '电信', '广电'];
  } catch {
    return ['移动', '联通', '电信', '广电'];
  }
}; 